import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ProvideAuth } from '~/hooks';
import { AuthRoute } from '~/components';
import { ROLES } from '~/util/auth';

import HomePage from '~/pages/HomePage';
import LoginPage from '~/pages/Login';
import ResetPasswordPage from '~/pages/ResetPasswordPage';
import PolicySearchRequestPage  from '~/pages/PolicySearchRequest/PolicySearchRequestPage';
import PolicySearchPage from '~/pages/PolicySearchRequest/PolicySearchPage';
import UnauthorizedPage from '~/pages/Unauthorized';
import RegisterPage from './pages/RegisterPage';
import AddUser from './pages/UserAdmin/AddUser';
import UserAdminPage from './pages/UserAdmin/UserAdminPage';
import EditUser from './pages/UserAdmin/EditUser';
import EditProfile from './pages/EditProfile';
import { PreliminaryTitleOpinion } from '~/pages/PreliminaryTitleOpinion/';
import { StraightToFinal }  from '~/pages/StraightToFinal/';
import { FinalTitleOpinion } from '~/pages/FinalTitleOpinion';
import SearchHistory from '~/pages/PolicySearchRequest/SearchHistory';
import SiteAdminPage from './pages/Admin/SiteAdminPage';
import ResourcesPage from './pages/Resources/ResourcesPage';
import OrderHistoryPage from './pages/OrderHistory';
import Toaster from './lib/Tracker/TrackerToaster';

import { useIdleTimer } from 'react-idle-timer';
// import ExportPriorPolicyPage from '~/pages/ExportData/ExportPriorPolicyPage';

function App() {

    const [timeForAlert, setTimeForAlert] = useState(false);
    const [warningTime, setWarningTime] = useState(59*60*1000);
    const [logOutTime] = useState(1*60*1000);

    const handleOnIdle = () => {
        if(window.location.pathname !== '/login') {
            setTimeForAlert(true);
            setTimeout(() => {
                setTimeForAlert(false);           
                window.location='/login';
            }, (logOutTime));
        }
    };

    const handleOnActive = () => {
        setWarningTime(59*60*1000);
        getRemainingTime();
    };

    

    const { getRemainingTime } = useIdleTimer({
        timeout: warningTime,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        debounce: 500,
        crossTab: true
    });

    return (
        <ProvideAuth>
            {
                timeForAlert 
                    ?
                    <Toaster 
                        isModalOpen
                        header='Session Expiration Warning'
                        body='Your session will expire in 1 minute due to inactivity. Click Cancel to continue your session.'
                        onCancel={() => {  
                            setTimeForAlert(false);
                            location.reload();
                        }}
                    />
                    :
                    <></>

            }

            <Router>
                <Switch>
                    <AuthRoute path="/" exact component={HomePage} />
                    <Route path="/login" exact component={LoginPage} />
                    <Route path="/resetpassword/:token" exact component={ResetPasswordPage} />
                    <Route path="/register" component={RegisterPage} />
                    <AuthRoute path="/policySearchHistory" component={SearchHistory} />
                    <AuthRoute path="/unauthorized" component={UnauthorizedPage} />
                    <AuthRoute roleId={[ROLES.FIRM_USER]} path="/policysearchrequest/:id?" component={PolicySearchRequestPage} />
                    <AuthRoute roleId={[ROLES.TRYON, ROLES.TRYON_BOT]} path="/policysearch/:id?" component={PolicySearchPage} />
                    {/*<AuthRoute roleId={[ROLES.ADMIN]} path="/export" component={ExportPriorPolicyPage} />*/}
                    <AuthRoute path="/preliminaryopinion/:id" component={PreliminaryTitleOpinion} />
                    <AuthRoute path="/StraightFinal/:id" component={StraightToFinal} />
                    <AuthRoute path="/finalopinion/:id" component={FinalTitleOpinion} />
                    <AuthRoute roleId={[ROLES.ADMIN, ROLES.FIRM_ADMIN]} path="/adduser" component={AddUser} />
                    <AuthRoute roleId={[ROLES.ADMIN, ROLES.FIRM_ADMIN]} path="/edituser/:userId" component={EditUser} />
                    <AuthRoute path="/editprofile" component={EditProfile} />
                    <AuthRoute roleId={[ROLES.ADMIN, ROLES.FIRM_ADMIN]} path="/useradmin" component={UserAdminPage}></AuthRoute>
                    {/* <AuthRoute roleId={[ROLES.FIRM_ADMIN]} path="/add-user" component={AddUserPage}></AuthRoute> */}
                    <AuthRoute roleId={[ROLES.ADMIN]} path="/siteadmin" component={SiteAdminPage}></AuthRoute>
                    <AuthRoute path="/orderhistory" component={OrderHistoryPage} />
                    <AuthRoute path="/resources" component={ResourcesPage} />
                </Switch>
            </Router>
        </ProvideAuth>
    );
}

export default App;
